import React from 'react';

export const Icon = ({ children, className, ...props }) => {
  return (
    <i className={['material-icons', className].join(' ')} {...props}>
      {children}
    </i>
  );
};
